module.exports = __webpack_public_path__ + "static/media/AB_O1_14.95cc4096.jpg";